import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerOfficialPatterns } from './config/registerOfficialPatterns';
import { registerSRDComposedMechanics } from './config/composedMechanicConfig';
import { captureSignupSource } from './utils/signupSource';

// Stash referrer + utm params before any navigation can scrub them.
captureSignupSource();

// Register all SRD campaign frame pattern components before render
registerOfficialPatterns();
// Register composed mechanic configs (SRD patterns migrated to engine)
registerSRDComposedMechanics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality with update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        // Check for updates every 30 seconds when page is visible
        setInterval(() => {
          if (document.visibilityState === 'visible') {
            registration.update();
          }
        }, 30000);

        // Listen for waiting service worker (new version available)
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available, show update notification
                showUpdateAvailable(registration);
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.error('SW registration failed: ', registrationError);
      });
  });
}

function showUpdateAvailable(registration) {
  // Create a subtle update notification
  const updateBanner = document.createElement('div');
  updateBanner.id = 'update-banner';
  updateBanner.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #4F46E5;
    color: white;
    padding: 12px;
    text-align: center;
    font-size: 14px;
    z-index: 10000;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  `;
  updateBanner.innerHTML = `
    ⬇️ New version available! Click to refresh and get the latest features.
  `;

  updateBanner.addEventListener('click', () => {
    // Tell the waiting service worker to activate
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    // Reload the page to get the new version
    window.location.reload();
  });

  // Remove existing banner if present
  const existingBanner = document.getElementById('update-banner');
  if (existingBanner) {
    existingBanner.remove();
  }

  document.body.appendChild(updateBanner);

  // Auto-hide after 10 seconds but leave it available
  setTimeout(() => {
    if (updateBanner.parentNode) {
      updateBanner.style.opacity = '0.8';
      updateBanner.style.fontSize = '12px';
      updateBanner.innerHTML = '⬇️ Update available - click to refresh';
    }
  }, 10000);
}
